module.exports = __webpack_public_path__ + "static/media/board-member-icon.d25b9821.png";